// FETCH ALL PROPERTIES FROM PROPERTY MASTER
export const FETCH_PROPERTY_MASTER_REQUEST = 'FETCH_PROPERTY_MASTER_REQUEST';
export const FETCH_PROPERTY_MASTER_SUCCESS = 'FETCH_PROPERTY_MASTER_SUCCESS';
export const FETCH_PROPERTY_MASTER_FAILURE = 'FETCH_PROPERTY_MASTER_FAILURE';

// FETCH IP ADDRESS
export const FETCH_IPADDRESS_REQUEST = 'FETCH_IPADDRESS_REQUEST';
export const FETCH_IPADDRESS_SUCCESS = 'FETCH_IPADDRESS_SUCCESS';
export const FETCH_IPADDRESS_FAILURE = 'FETCH_IPADDRESS_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_PROPERTY_MASTER = 'CREATE_USER_FORM_PROPERTY_MASTER';

//UPDATE USER FORM
export const UPDATE_USER_FORM_PROPERTY_MASTER = 'UPDATE_USER_FORM_PROPERTY_MASTER';

// CREATE PROPERTIES FOR PROPERTY MASTER
export const CREATE_PROPERTY_MASTER_REQUEST = 'CREATE_PROPERTY_MASTER_REQUEST';
export const CREATE_PROPERTY_MASTER_SUCCESS = 'CREATE_PROPERTY_MASTER_SUCCESS';
export const CREATE_PROPERTY_MASTER_FAILURE = 'CREATE_PROPERTY_MASTER_FAILURE';

//SET_ACTIVE
export const PROPERTY_MASTER_SET_ACTIVE_REQUEST = 'PROPERTY_MASTER_SET_ACTIVE_REQUEST';
export const PROPERTY_MASTER_SET_ACTIVE_SUCCESS = 'PROPERTY_MASTER_SET_ACTIVE_SUCCESS';
export const PROPERTY_MASTER_SET_ACTIVE_FAILURE = 'PROPERTY_MASTER_SET_ACTIVE_FAILURE';

// UPDATE PROPERTIES FOR PROPERTY MASTER
export const UPDATE_PROPERTY_MASTER_REQUEST = 'UPDATE_PROPERTY_MASTER_REQUEST';
export const UPDATE_PROPERTY_MASTER_SUCCESS = 'UPDATE_PROPERTY_MASTER_SUCCESS';
export const UPDATE_PROPERTY_MASTER_FAILURE = 'UPDATE_PROPERTY_MASTER_FAILURE';

// FETCH SINGLE PROPERTY
export const FETCH_SINGLE_PROPERTY_MASTER_REQUEST = 'FETCH_SINGLE_PROPERTY_MASTER_REQUEST';
export const FETCH_SINGLE_PROPERTY_MASTER_SUCCESS = 'FETCH_SINGLE_PROPERTY_MASTER_SUCCESS';
export const FETCH_SINGLE_PROPERTY_MASTER_FAILURE = 'FETCH_SINGLE_PROPERTY_MASTER_FAILURE';

// DELETE PROPERTIES FOR PROPERTY MASTER
export const DELETE_PROPERTY_MASTER_REQUEST = 'DELETE_PROPERTY_MASTER_REQUEST';
export const DELETE_PROPERTY_MASTER_SUCCESS = 'DELETE_PROPERTY_MASTER_SUCCESS';
export const DELETE_PROPERTY_MASTER_FAILURE = 'DELETE_PROPERTY_MASTER_FAILURE';

export const PROPERTY_MASTER_USERFORM_RESET = 'PROPERTY_MASTER_USERFORM_RESET';
